import { z } from 'zod'

import { FieldStatuses } from 'common/fields/constants/FieldType'
import { FieldSegmentType, FieldType } from 'common/fields/entities/enums'

export const GlobalFieldIdSchema = z.number()
export const GlobalFieldValueSchema = z.union([z.string(), z.number(), z.boolean()]).nullable()

export const NewGlobalFieldSchema = z.object({
  caption: z.string(),
  type: z.enum(FieldType),
  description: z.string(),
  value: GlobalFieldValueSchema,
  path: z.string().optional(),
})

export const GlobalFieldSchema = z.object({
  field_id: GlobalFieldIdSchema,
  type: z.enum(FieldType),
  segment_type: z.enum(FieldSegmentType),
  caption: z.string(),
  description: z.string().nullable(),
  value: GlobalFieldValueSchema,
  status: z.enum(FieldStatuses),
  is_template_field: z.boolean(),
  template_installation_id: z.number().nullable(),
  folder_id: z.number(),
})

export type NewGlobalField = z.infer<typeof NewGlobalFieldSchema>
export type GlobalField = z.infer<typeof GlobalFieldSchema>
